import styled from 'styled-components';
import { SubMenuBody } from './submenu/SubMenuBody';

// 메인메뉴(EN/US/KR) 공통 구분선
export const Divider = styled.div`
  height: 1px;
  flex-shrink: 0;
  background-color: #eef1f6;
  margin: 0.8rem 0;

  /* 펼쳐진 하위메뉴(SubMenuBody) 바로 뒤에 올 때만 위쪽 여백 제거 → 회색 블록에 붙인다 */
  ${SubMenuBody} + & {
    margin-top: 0;
  }
`;
